// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MarkPropertyAsSoldDialog = require("../ClientPage/MarkPropertyAsSoldDialog.bs.js");
let MyClientsWidgetRowLayout = require("./MyClientsWidgetRowLayout.bs.js");
let MyClientsWidgetComponents = require("./MyClientsWidgetComponents.bs.js");
let MyClientsWidgetDeleteDialog = require("./MyClientsWidgetDeleteDialog.bs.js");
let RenewForSalePropertyMutation = require("../ClientPage/RenewForSalePropertyMutation.bs.js");
let OwnForSalePropertyStatusLabel = require("../OwnForSalePropertyStatusLabel.bs.js");
let WithdrawForSalePropertyDialog = require("../ClientPage/WithdrawForSalePropertyDialog.bs.js");
let MarkPropertyAsUnderContractDialog = require("../ClientPage/MarkPropertyAsUnderContractDialog.bs.js");
let MyClientsWidgetSeller_seller_graphql = require("../../../__generated__/MyClientsWidgetSeller_seller_graphql.bs.js");
let MyClientsWidgetSeller_Menu_seller_graphql = require("../../../__generated__/MyClientsWidgetSeller_Menu_seller_graphql.bs.js");
let MyClientsWidgetSeller_name_seller_graphql = require("../../../__generated__/MyClientsWidgetSeller_name_seller_graphql.bs.js");
let MyClientsWidgetSeller_status_seller_graphql = require("../../../__generated__/MyClientsWidgetSeller_status_seller_graphql.bs.js");

let convertFragment = MyClientsWidgetSeller_Menu_seller_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetSeller_Menu_seller_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_Menu_seller_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetSeller_Menu_seller_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetSeller_Menu_seller_graphql.node, convertFragment, fRef);
}

let SellerFragment_forSalePropertyMatchingType_decode = MyClientsWidgetSeller_Menu_seller_graphql.Utils.forSalePropertyMatchingType_decode;

let SellerFragment_forSalePropertyMatchingType_fromString = MyClientsWidgetSeller_Menu_seller_graphql.Utils.forSalePropertyMatchingType_fromString;

let SellerFragment = {
  forSalePropertyMatchingType_decode: SellerFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: SellerFragment_forSalePropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetSeller$Menu(props) {
  let seller = RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_Menu_seller_graphql.node, convertFragment, props.seller);
  let match = seller.property.status;
  let isArchived;
  switch (match.__typename) {
    case "ActiveProperty" :
    case "__unselected" :
      isArchived = false;
      break;
    default:
      isArchived = match.archived;
  }
  let hasActivityReport = Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.map(seller.property.broadcasts, connection => connection.edges), [])).some(edge => {
    let match = edge.node.activityReport;
    return match.__typename === "ActivityReportV5";
  });
  let matchesCount = Stdlib_Option.getOr(Stdlib_Option.map(seller.property.matches, m => m.totalCount), 0);
  let match$1 = React.useState(() => false);
  let setDeleteDialogOpen = match$1[1];
  let match$2 = SystemMessages.useSystemMessages();
  let addMessage = match$2.addMessage;
  let handleRenewingError = () => addMessage(SystemMessages.Message.make(undefined, "error", "There was an error making the property active. Please try again...", 5000, undefined, undefined));
  let match$3 = RenewForSalePropertyMutation.use(seller.property.id, seller.property.nodeId, handleRenewingError, false);
  let makePropertyActiveIsLoading = match$3[1];
  let makePropertyActive = match$3[0];
  let match$4 = React.useState(() => false);
  let setMarkPropertyAsSoldDialogOpen = match$4[1];
  let match$5 = React.useState(() => false);
  let setUnderContractDialogOpen = match$5[1];
  let match$6 = React.useState(() => false);
  let setWithdrawPropertyDialogOpen = match$6[1];
  let match$7 = seller.property.forSaleMatchingType;
  let name;
  name = match$7 === "BROADCAST" ? "Rebroadcast property" : "Broadcast property";
  let match$8 = seller.property.status;
  let name$1;
  switch (match$8.__typename) {
    case "ActiveProperty" :
      name$1 = match$8.isRenewable ? "Renew or change status" : "Change status";
      break;
    case "ExpiredProperty" :
      name$1 = "Renew or change status";
      break;
    default:
      name$1 = "Change status";
  }
  let tmp;
  if (isArchived) {
    tmp = JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
      name: name$1,
      unavailableReason: "The property has been archived",
      unavailableDescription: "Archived properties cannot be renewed or have their status changed."
    });
  } else {
    let match$9 = seller.property.status;
    let tmp$1;
    let exit = 0;
    switch (match$9.__typename) {
      case "ActiveProperty" :
        if (match$9.isRenewable) {
          exit = 1;
        } else {
          tmp$1 = null;
        }
        break;
      case "ExpiredProperty" :
        exit = 1;
        break;
      default:
        tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: () => {
            makePropertyActive();
          },
          isDisabled: makePropertyActiveIsLoading,
          children: "Change to active"
        });
    }
    if (exit === 1) {
      tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => {
          makePropertyActive();
        },
        isDisabled: makePropertyActiveIsLoading,
        children: "Renew property"
      });
    }
    let match$10 = seller.property.status;
    let tmp$2;
    tmp$2 = match$10.__typename === "SoldProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => setMarkPropertyAsSoldDialogOpen(param => true),
        children: "Mark as sold"
      });
    let match$11 = seller.property.status;
    let tmp$3;
    tmp$3 = match$11.__typename === "UnderContractProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => setUnderContractDialogOpen(param => true),
        children: "Mark as under contract"
      });
    let match$12 = seller.property.status;
    let tmp$4;
    tmp$4 = match$12.__typename === "WithdrawnProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => setWithdrawPropertyDialogOpen(param => true),
        children: "Withdraw property"
      });
    tmp = JsxRuntime.jsxs(MenuV5.Submenu.make, {
      name: name$1,
      children: [
        tmp$1,
        tmp$2,
        tmp$3,
        tmp$4
      ],
      isDisabled: isArchived
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(MarkPropertyAsSoldDialog.make, {
        propertyId: seller.property.id,
        isOpen: match$4[0],
        close: () => setMarkPropertyAsSoldDialogOpen(param => false)
      }),
      JsxRuntime.jsx(WithdrawForSalePropertyDialog.make, {
        propertyId: seller.property.id,
        isOpen: match$6[0],
        close: () => setWithdrawPropertyDialogOpen(param => false)
      }),
      JsxRuntime.jsx(MarkPropertyAsUnderContractDialog.make, {
        propertyId: seller.property.id,
        isOpen: match$5[0],
        close: () => setUnderContractDialogOpen(param => false)
      }),
      JsxRuntime.jsx(MyClientsWidgetDeleteDialog.make, {
        client: seller.fragmentRefs,
        isOpen: match$1[0],
        onCancel: () => setDeleteDialogOpen(param => false),
        onSuccess: () => setDeleteDialogOpen(param => false),
        connectionId: props.connectionId
      }),
      JsxRuntime.jsxs(MenuV5.Menu.make, {
        button: JsxRuntime.jsx(ButtonsV5.Button.make, {
          className: "!border-none",
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "three-dots",
            size: 16,
            className: "text-black"
          })
        }),
        children: [
          isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
              name: "Edit property",
              unavailableReason: "The property has been archived",
              unavailableDescription: "Archived properties cannot be edited."
            }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: `/properties/` + seller.property.id + `/edit`,
              children: "Edit property"
            }),
          isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
              name: name,
              unavailableReason: "The property has been archived",
              unavailableDescription: "Archived properties cannot be broadcasted."
            }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: `/properties/` + seller.property.id + `/broadcast`,
              children: name
            }),
          tmp,
          matchesCount > 0 ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: `/my_clients/` + seller.id + `#matches`,
              children: `View matches (` + matchesCount.toString() + `)`
            }) : null,
          hasActivityReport ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: `/properties/` + seller.property.id + `/report`,
              children: "View activity report"
            }) : null,
          isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
              name: "Delete seller",
              unavailableReason: "The property has been archived",
              unavailableDescription: "Archived properties cannot be deleted."
            }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
              onAction: () => setDeleteDialogOpen(param => true),
              children: "Delete seller"
            })
        ]
      })
    ]
  });
}

let Menu = {
  SellerFragment: SellerFragment,
  make: MyClientsWidgetSeller$Menu
};

let convertFragment$1 = MyClientsWidgetSeller_name_seller_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetSeller_name_seller_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_name_seller_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetSeller_name_seller_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetSeller_name_seller_graphql.node, convertFragment$1, fRef);
}

let SellerFragment_forSalePropertyMatchingType_decode$1 = MyClientsWidgetSeller_name_seller_graphql.Utils.forSalePropertyMatchingType_decode;

let SellerFragment_forSalePropertyMatchingType_fromString$1 = MyClientsWidgetSeller_name_seller_graphql.Utils.forSalePropertyMatchingType_fromString;

let SellerFragment_visibilityReason_decode = MyClientsWidgetSeller_name_seller_graphql.Utils.visibilityReason_decode;

let SellerFragment_visibilityReason_fromString = MyClientsWidgetSeller_name_seller_graphql.Utils.visibilityReason_fromString;

let SellerFragment$1 = {
  forSalePropertyMatchingType_decode: SellerFragment_forSalePropertyMatchingType_decode$1,
  forSalePropertyMatchingType_fromString: SellerFragment_forSalePropertyMatchingType_fromString$1,
  visibilityReason_decode: SellerFragment_visibilityReason_decode,
  visibilityReason_fromString: SellerFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyClientsWidgetSeller$Name(props) {
  let seller = RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_name_seller_graphql.node, convertFragment$1, props.seller);
  let match = seller.property.forSalePropertyMatchingType;
  let tmp;
  if (match === "BROADCAST" || match === "QUIET_ANONYMOUS" || match === "ONE_WAY" || match === "QUIET") {
    switch (match) {
      case "BROADCAST" :
        tmp = "Broadcast property";
        break;
      case "ONE_WAY" :
        tmp = "Hidden property";
        break;
      case "QUIET" :
        tmp = "Quiet property";
        break;
      case "QUIET_ANONYMOUS" :
        tmp = "Quiet anonymous property";
        break;
    }
  } else {
    tmp = "Broadcast property";
  }
  let match$1 = seller.property.propertyLocation;
  let tmp$1;
  if (match$1 !== undefined && match$1.__typename === "PropertyLocationWithVisibleAddress") {
    let match$2 = match$1.visibilityRule;
    tmp$1 = match$2 === "VISIBLE_TO_ACCOUNT_MEMBER" ? JsxRuntime.jsx(MyClientsWidgetComponents.HiddenAddressIcon.make, {}) : null;
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: tmp,
            className: "text-gray-500 uppercase font-light"
          }),
          tmp$1
        ],
        className: "flex gap-2 items-center"
      }),
      JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: `my_clients/` + seller.id,
        children: JsxRuntime.jsx("div", {
          children: seller.displayName,
          className: "text-lg"
        })
      })
    ],
    className: "flex flex-col gap-1"
  });
}

let Name = {
  SellerFragment: SellerFragment$1,
  make: MyClientsWidgetSeller$Name
};

let convertFragment$2 = MyClientsWidgetSeller_status_seller_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetSeller_status_seller_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_status_seller_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetSeller_status_seller_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetSeller_status_seller_graphql.node, convertFragment$2, fRef);
}

let SellerFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyClientsWidgetSeller$Status$WithoutErrorBoundary(props) {
  let seller = RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_status_seller_graphql.node, convertFragment$2, props.seller);
  return JsxRuntime.jsx(OwnForSalePropertyStatusLabel.make, {
    forSaleProperty: seller.property.fragmentRefs
  });
}

let WithoutErrorBoundary = {
  ForSalePropertyStatusLabel: undefined,
  SellerFragment: SellerFragment$2,
  make: MyClientsWidgetSeller$Status$WithoutErrorBoundary
};

function MyClientsWidgetSeller$Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "seller status",
    children: JsxRuntime.jsx(MyClientsWidgetSeller$Status$WithoutErrorBoundary, {
      seller: props.seller
    })
  });
}

let Status = {
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: MyClientsWidgetSeller$Status
};

let convertFragment$3 = MyClientsWidgetSeller_seller_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetSeller_seller_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_seller_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetSeller_seller_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetSeller_seller_graphql.node, convertFragment$3, fRef);
}

let SellerFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function MyClientsWidgetSeller(props) {
  let seller = RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_seller_graphql.node, convertFragment$3, props.seller);
  return JsxRuntime.jsx(MyClientsWidgetRowLayout.make, {
    name: JsxRuntime.jsx(MyClientsWidgetSeller$Name, {
      seller: seller.fragmentRefs
    }),
    status: JsxRuntime.jsx(MyClientsWidgetSeller$Status, {
      seller: seller.fragmentRefs
    }),
    menu: JsxRuntime.jsx(MyClientsWidgetSeller$Menu, {
      seller: seller.fragmentRefs,
      connectionId: props.connectionId
    })
  });
}

let Layout;

let Components;

let Link;

let DeleteDialog;

let make = MyClientsWidgetSeller;

exports.Layout = Layout;
exports.Components = Components;
exports.Link = Link;
exports.DeleteDialog = DeleteDialog;
exports.Menu = Menu;
exports.Name = Name;
exports.Status = Status;
exports.SellerFragment = SellerFragment$3;
exports.make = make;
/* react Not a pure module */
